import { render, staticRenderFns } from "./TransportVehiclePopup.vue?vue&type=template&id=39cc969c&scoped=true&"
import script from "./TransportVehiclePopup.vue?vue&type=script&lang=js&"
export * from "./TransportVehiclePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc969c",
  null
  
)

export default component.exports